<template>
  <div class="info-container">
    <div class="info-row">
      <div class="info-label">托管人：</div>
      <div class="info-value">
        {{ info.farmerName != null ? info.farmerName.substr(0, 1) : "" }}
        {{ info.sex == "2" ? "女士" : "先生" }}
      </div>
    </div>
    <div class="info-row">
      <div class="info-label">联系电话：</div>
      <div class="info-value">{{ info.farmerPhone }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">托管类型：</div>
      <div class="info-value">
        {{ info.orderType === '1' ? `全程托管` : `环节托管` }}
      </div>
    </div>
    <div class="info-row">
      <div class="info-label">托管环节：</div>
      <div class="info-value">{{ info.orderContent }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">作物类型：</div>
      <div class="info-value">{{ info.cropCode }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">每季保底产量：</div>
      <div class="info-value">
        {{ info.seasonYield != null ? `${info.seasonYield} KG/亩` : "" }}
      </div>
    </div>
    <div class="info-row">
      <div class="info-label">土地面积：</div>
      <div class="info-value">{{ info.landArea }}亩</div>
    </div>
    <div class="info-row">
      <div class="info-label">地址：</div>
      <div class="info-value">{{ info.areaName }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">托管时间：</div>
      <div class="info-value">{{ info.startDate }}~{{ info.endDate }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">总价：</div>
      <div class="info-value">
        {{ info.estimatePrice == null ? "" : `${info.estimatePrice} 元` }}
      </div>
    </div>
    <div class="info-row">
      <div class="info-label">其他说明：</div>
      <div class="info-value">{{ info.remark == null ? "" : info.remark }}</div>
    </div>
    <div class="info-row image-row">
      <div class="info-label">现场照片：</div>
      <div class="info-value image-grid">
        <el-image
          style="width: 100px; height: 100px"
          :src="item"
          v-for="(item, index) in livePhotoList"
          :key="index"
          :preview-src-list="livePhotoList"
        />
      </div>
    </div>
    <div class="info-row button-row">
      <el-button class="custom-button" @click="handleClick(info)">
        在线沟通
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SendMessage, companyByid } from "@/api/websocket.js";
import { getStore } from "@/js/utils/store";
export default {
  props: ["info"],
  data() {
    return {
      shouldLoadImages: false, // 控制是否加载图片
    };
  },
  mounted() {
    // 监听popupopen事件，当弹窗打开时加载图片
    this.$el.addEventListener('DOMNodeInserted', this.handlePopupOpen);
  },
  beforeUnmount() {
    // 清理事件监听器
    if (this.$el) {
      this.$el.removeEventListener('DOMNodeInserted', this.handlePopupOpen);
    }
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),

    livePhotoList() {
      // 只有当组件需要显示时才加载图片
      if (this.shouldLoadImages) {
        const livePhoto = this.info.livePhotos;
        const livePhotoList = [];
        if (livePhoto) {
          const livePhotoArr = JSON.parse(livePhoto);
          livePhotoArr.forEach((item) => {
            livePhotoList.push(
              window.globalUrl.HOME_API + "admin/file/get?ossFilePath=" + item.url
            );
          });
        }
        return livePhotoList;
      }
      // 返回空数组，直到需要加载图片为止
      return [];
    },
  },
  methods: {
    /**
     * 处理popup打开事件
     */
    handlePopupOpen() {
      // 延迟一小段时间确保DOM完全渲染后再加载图片
      setTimeout(() => {
        this.shouldLoadImages = true;
      }, 200);
    },

    /**
     * 在线沟通
     */
    async handleClick(info) {
      console.log(info);
      let token = getStore({ name: "access_token" });
      if (!token) {
        this.$router.push({ name: "login" });
        this.$message.error("用户凭证已过期");
        return;
      }
      if (info.authId == this.identityObj.identityId) {
        this.$message.info("本人项目");
      } else {
        let params = {
          messageList: [
            {
              //消息类型会话接管
              messageType: 4,
              // content: content2,
            },
          ],
          receiverId: info.authId,
          senderType: this.identityObj.identityTypeCode,
          //接受消息人类型只有个人认证用户
          receiverType: 2,
          senderId: this.identityObj.identityId,
          sender: this.identityObj.realName,
          receiver: info.farmerName,
        };
        let res = await SendMessage(params);
        if (res.code == 0) {
          this.$router.push({
            path: "/home/Chat",
            query: {
              isshow: true, // 你要传递的参数
              data: info,
              num: 3,
            },
          });
        }
      }
    },
  },
};
</script>


<style scoped lang="less" >
@import "~@/styles/JStyle";
</style>
